import { render, staticRenderFns } from "./ModuleBrandNew.vue?vue&type=template&id=ea630eb2&"
import script from "./ModuleBrandNew.vue?vue&type=script&lang=js&"
export * from "./ModuleBrandNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports